<template>
  <el-container class="main-page">
    <el-aside :width="collapse ? '64px' : '15vw'" id="selfAisde" class="self-aside">
      <self-navbar></self-navbar>
    </el-aside>
    <el-container>
      <el-header class="main-header" height="6vh">
        <self-header :title="'欢迎'"></self-header>
      </el-header>
      <el-main class="content-view">
        <transition name="slide-fade">
          <router-view :key="$route.fullPath" />
        </transition>
      </el-main>
      <el-footer class="self-footer" height="3vh">
        <div class="text-center show-pc">
          <div @click="versionShow">版本号:{{ version }}</div>
        </div>
        <div class="text-center show-phone" v-if="showBar()">
          <van-tabbar route v-model="active" @change="onChange">
            <van-tabbar-item replace to="/main/customer" icon="user-o">客户中心</van-tabbar-item>
            <van-tabbar-item replace to="/main/case" icon="description">案件中心</van-tabbar-item>
            <!-- <van-tabbar-item replace to="/flow/flowList" icon="exchange">公司流水</van-tabbar-item> -->
          </van-tabbar>
        </div>
      </el-footer>
    </el-container>
  </el-container>
</template>
<script>
import selfNavbar from '../components/Navbar'
import selfHeader from '../components/Header'
import bus from '../store/bus'
export default {
  components: {
    selfHeader,
    selfNavbar
  },
  data() {
    return {
      userInfo: {},
      version: '',
      active: 0,
      collapse: false
    }
  },
  watch: {
    $route: 'routerChange'
  },
  methods: {
    routerChange() {
      if (this.$route.name === 'Case') {
        this.active = 1
      } else if (this.$route.name === 'Customer') {
        this.active = 0
      } else if (this.$route.name === 'Flow') {
        this.active = 2
      } else {
        this.active = ''
      }
    },
    versionQuery() {
      const param = {
        facet: 'A'
      }
      this.$get('/version/query', param).then(
        result => {
          if (result.status === 200) {
            this.version = result.data[0].version
          } else {
            this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    versionShow() {
      console.log('a')
      this.$router.push({
        name: 'Version'
      })
    },
    onChange(index) {
      console.log(index)
    },
    showBar() {
      console.log(this.$route.path.indexOf('case') >= 0 || this.$route.path.indexOf('customer') >= 0)
      if (this.$route.path.indexOf('case') >= 0 || this.$route.path.indexOf('customer') >= 0) {
        return true
      } else {
        return false
      }
    }
  },
  created() {
    bus.$on('collapse-content', msg => {
      this.collapse = msg
    })
    // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
    bus.$on('collapse', msg => {
      this.collapse = msg
      bus.$emit('collapse-content', msg)
    })
  },
  mounted() {
    if (this.$route.name === 'Case') {
      this.active = 1
    } else if (this.$route.name === 'Customer') {
      this.active = 0
    } else {
      this.active = ''
    }
    console.log(this.$route)
    this.versionQuery()
  },
  beforeDestroy() {}
}
</script>
<style scoped lang="less">
/* 整个区域 */
.main-page {
  .main-header {
    height: 6vh;
    padding: 0;
    z-index: 9;
  }
  .self-aside {
    position: relative;
    transition: all ease-out 800ms;
    overflow-x: hidden;
    ul {
      background: #fff;
    }
  }
  .content-view {
    padding: 0;
    height: 91vh;
    overflow-x: hidden;
    overflow-y: auto;
    background: #f0f0f0;
  }
  .self-footer {
    position: relative;
    text-align: center;
    line-height: 3vh;
    font-size: 12px;
    color: #666;
  }
}
@media screen and (max-width: 768px) {
  .main-page {
    .self-aside {
      width: 100%;
      position: fixed;
      display: none;
    }
    .main-header {
      height: 5vh !important;
    }
    .content-view {
      padding: 0;
      height: 85vh;
      overflow-x: hidden;
      overflow-y: auto;
      background: #f0f0f0;
    }
    .self-footer {
      // position: fixed;
      width: 100%;
      bottom: 0;
      height: 6vh !important;
      // display: none;
    }
  }
}
</style>
